import { render } from "./SocialMedia.vue?vue&type=template&id=7469b8cf"
import script from "./SocialMedia.vue?vue&type=script&lang=js"
export * from "./SocialMedia.vue?vue&type=script&lang=js"
script.render = render

export default script